import React from 'react'
import {Document, Page, Text, View} from "@react-pdf/renderer";

import { baseStyles} from "../../styles";
import {AmountDueAtSigningPDF} from "../../components/AmountDueAtSigningPDF";
import {PaymentInformationPDF} from "../../components/PaymentInformationPDF";
import {TaxInformationPDF} from "../../components/TaxInformationPDF";
import {FeeBreakdownPDF} from "../../components/FeeBreakdownPDF";
import {RateInformationPDF} from "../../components/RateInformationPDF";
import {CapitalizedCostBreakdownPDF} from "../../components/CapitalizedCostBreakdownPDF";
import {MileageInformationPDF} from "../../components/MileageInformationPDF";
import {ProfitInformationPDF} from "../../components/ProfitInformationPDF";
import {ResidualInformationPDF} from "../../components/ResidualInformationPDF";
import {TradeInformationPDF} from "../../components/TradeInformationPDF";
import {VehicleInfoPDF} from "../../components/VehicleInfoPDF";
import {HeaderPDF} from "../../components/HeaderPDF";
import {RebatesBreakdownPDF} from "../../components/RebatesBreakdownPDF";
import {BasePDF} from "../../BasePDF";
import {FooterPDF} from "../../components/FooterPDF";

export const DealerDisclosurePDF = ({companyName, dealState, ...props}) => {
    return (
        <BasePDF dealState={dealState} {...props}>
            <Document>
                <Page size="A4" style={baseStyles.page} wrap={false}>
                    <HeaderPDF pdfName={'Dealer Worksheet'} companyName={companyName}/>

                    <VehicleInfoPDF/>

                    <View style={{...baseStyles.tablesLayout}}>
                        <View style={{...baseStyles.flexColumn, ...baseStyles.leftColumn}}>
                            <AmountDueAtSigningPDF isDealerDisclosure={true}/>
                            <PaymentInformationPDF/>
                            <RateInformationPDF/>
                            <ProfitInformationPDF/>
                            <TradeInformationPDF isDealerDisclosure={true}/>
                            <TaxInformationPDF />
                        </View>

                        <View style={{...baseStyles.flexColumn, ...baseStyles.rightColumn}}>
                            <CapitalizedCostBreakdownPDF />
                            <ResidualInformationPDF isDealerDisclosure={true}/>
                            <MileageInformationPDF isDealerDisclosure={true}/>
                            <RebatesBreakdownPDF/>
                            <FeeBreakdownPDF />
                        </View>
                    </View>
                    <FooterPDF/>
                </Page>
            </Document>
        </BasePDF>
    )
}